import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getTerminals = (
  {
    currentPage,
    pageSize,
    params = {}
  }: {
    currentPage: number;
    pageSize: number;
    params?: Record<string, string | number | boolean | undefined>;
  }
) => {
  const queryParams: Record<string, string | number | boolean> = {
    page: currentPage,
    page_size: pageSize,
    ...params
  };
  if (queryParams.branch_id === undefined) delete queryParams.branch_id;
  return axiosPrivate.get("/dashboard/api/v1/terminals", { params: queryParams });
};

export type UpdateTerminalBranchBody = {
  branch_id: string;
};

export const updateTerminalBranch = (id: string, body: UpdateTerminalBranchBody) => {
  return axiosPrivate.put(`/dashboard/api/v1/terminals/${id}`, body);
};